



























import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api'
import HubContent from '~/components/solepro/HubContent.vue';
import { useContent } from "~/composables";
import { getMetaInfo } from '~/helpers/getMetaInfo';



export default defineComponent({
  components: { HubContent },
  head() {
        return {
            ...getMetaInfo({
                title: 'Hub',
            }, false, 'page')
        }
    },
    setup() {
        const { loadBlocks } = useContent();
        const hubContent = ref()
        useFetch(async () => {
            const cmsContent = await loadBlocks({ identifiers: ["solepro_hub_content"] });
            hubContent.value = cmsContent[0]?.content
        })
        return {
            hubContent
        }
    }
    
})
